import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import FullCalendar from "@fullcalendar/react";
import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import Select from "react-select";
import { handleDatesSet } from "../../utils";
import styles from "./Calendar.module.css";

function RoomCalendar({ cityProps, roomProps, calendarControls, stateData }) {
  const { citiesForSecond, handleCityChange, selectedCity } = cityProps;

  const { secondRooms, selectedRooms } = roomProps;

  const {
    handleDateChange,
    setStartDateSecond,
    setEvents,
    setStartDate,
    setEndDate,
    handleDateClick,
    handleEventClick,
  } = calendarControls;

  const {
    selectStyles,
    calendarRef,
    authToken,
    role,
    transformedEventsRoomCalendar,
    userData,
    startDateSecond,
    startDate,
    endDate,
  } = stateData;

  return (
    <div style={{ padding: "0px 16px" }}>
      <h1 className={styles.title}>Pregled po sobama</h1>
      <div className={styles.row}>
        <div className={styles.col}>
          <label htmlFor="dateSelect" className={styles.label}>
            Odaberi grad
          </label>
          <Select
            options={citiesForSecond}
            styles={selectStyles}
            onChange={handleCityChange}
            value={selectedCity}
            isSearchable={false}
            isDisabled={false}
            components={{ IndicatorSeparator: () => null }}
          />
        </div>
        <div className={styles.col}>
          <label htmlFor="dateSelect" className={styles.label}>
            Odaberi datum
          </label>
          <input
            type="date"
            onKeyDown={(e) => e.preventDefault()}
            className={"date-select-calendar"}
            onChange={(e) => handleDateChange(e, setStartDateSecond)}
            value={startDateSecond}
          />
        </div>
      </div>
      <div className="fc2">
        <FullCalendar
          ref={calendarRef}
          height="75vh"
          plugins={[
            dayGridPlugin,
            timeGridPlugin,
            resourceTimeGridPlugin,
            interactionPlugin,
            listPlugin,
          ]}
          headerToolbar={{
            right: "prev,today,next",
            left: "title",
          }}
          dateClick={() => {}}
          initialView="resourceTimeGridDay"
          editable={false}
          selectable={true}
          resourceAreaHeaderContent="Sobe"
          resources={secondRooms}
          resourceOrder={secondRooms?.[0]?.id}
          datesSet={(info) =>
            handleDatesSet(
              info,
              selectedRooms,
              authToken,
              setEvents,
              setStartDate,
              setEndDate,
              startDate,
              endDate
            )
          }
          selectMirror={true}
          dayMaxEvents={true}
          select={role !== "Polaznik" && ((info) => handleDateClick(info))}
          eventClick={handleEventClick}
          events={transformedEventsRoomCalendar}
          slotMinTime="07:00:00"
          slotMaxTime="21:15:00"
          eventContent={(props) => (
            <div
              style={{
                backgroundColor:
                  props.event.extendedProps.userId === userData.id ||
                  props.event.extendedProps.supervisorId === userData.id
                    ? "#3eb489"
                    : "#cb9c2d",
              }}
              className={styles.events}
            >
              {props.event.title.toLocaleLowerCase()}
              {props.event.userId}
            </div>
          )}
          allDaySlot={false}
          slotLabelContent={(slotInfo) => {
            const hours = slotInfo.date.getHours();
            const minutes = slotInfo.date
              .getMinutes()
              .toString()
              .padStart(2, "0");

            return (
              <span className={styles.time}>{`${hours}:${minutes}`} </span>
            );
          }}
          slotLabelInterval={{ minutes: 30 }}
        />
      </div>
    </div>
  );
}

export default RoomCalendar;
